import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class ApplyCompleteController extends Controller {
  @service
  router;

  @action
  routeNewApplication() {
    this.router.transitionTo(
      'apply',
      this.schema.countryCode,
      this.schema.schoolCode,
    );
  }
}
